import { getDateTime } from "../../services/CheckMeProBlePackages";
import { ECGInnerItem    } from "./ECGInnerItem";
export interface SPO2Item{

    date: Date
    measuringMode: number
    oxygen: number
    pr : number
    pi:number
    imgResultDescr:string
  
   
}



const PACKAGESIZE =12

export function parseSPO2Items(bytes: number[]  ) : SPO2Item[]{
    
    let start = 0
 
    const returnList:  SPO2Item[] = new Array();
    for (let k = 0; k < bytes.length -8; k++) {
        if ( start +PACKAGESIZE >= bytes.length  )
            break;
        const user = {} as SPO2Item
        returnList.push(user)

        start = k * PACKAGESIZE
         user.date = getDateTime(bytes,start)
        user.measuringMode = bytes[start + 7]
        
         user.oxygen = bytes[start + 8]
        
         user.pr =  bytes[start + 9]; 
         user.pi =  bytes[start + 10]; 
         
      

    }

    return returnList;

}